import { v2Api } from './v2Client';

/** Droits du staff du club sur les équipes et rencontres du club (l'app mobile ne l'envoie pas : capitaine seulement). */
const STAFF_MODE = { headers: { 'X-Staff-Mode': '1' } };
const post = (url, body) => v2Api.post(url, body ?? {}, STAFF_MODE).then((r) => r.data);

/**
 * Interclubs (API `Interclub/*`, docs/INTERCLUB.md) : compétitions par équipes entre clubs. Les compétitions, divisions,
 * équipes et calendriers appartiennent à la Ligue (MySquash, routes `admin_*`, interdites au club). L'ERP voit les
 * équipes de son club (`my`), gère leur effectif, capitaine et T1 (`team_*`), et compose / encode les rencontres où
 * joue une de ses équipes, avec les mêmes routes que les capitaines dans l'app. Refus : statut HTTP + `{ error, message }`.
 */

export const INTERCLUB_KIND_OPTIONS = [
  { value: 'federal', label: 'Fédéral' },
  { value: 'regional', label: 'Régional' },
  { value: 'veterans', label: '+35 (vétérans)' },
  { value: 'under35', label: '-35' },
  { value: 'ladies', label: 'Dames' },
  { value: 'other', label: 'Autre' },
];

/** Statut effectif d'une rencontre (`InterclubFixtureDto.status`). */
export const INTERCLUB_FIXTURE_STATUS_LABELS = {
  scheduled: 'Programmée',
  lineup: 'Compositions faites',
  in_progress: 'En cours',
  played: 'Jouée',
  forfeit: 'Forfait',
  postponed: 'Reportée',
  cancelled: 'Annulée',
};

/** Message d'un refus de l'API (le `message` lisible renvoyé avec le code), sinon `fallback`. */
export function interclubErrorMessage(err, fallback = 'Erreur') {
  return err?.response?.data?.message || err?.message || fallback;
}

export const interclubService = {
  // ── Équipes du club (staff du club de l'équipe, son capitaine ou la Ligue) ──
  /** `{ captain_player_id?, t1_player_id?, clear?: ['captain_player_id' | 't1_player_id'] }` → InterclubTeamDto */
  updateTeam: (teamId, body) => post('/Interclub/team_update', { id: teamId, ...body }),
  /** `{ player_id }` (membre du club) ou `{ guest_name }` (fiche invitée dans le club) → effectif complet. */
  addRoster: (teamId, ref) => post('/Interclub/team_roster_add', { team_id: teamId, ...ref }),
  removeRoster: (teamId, playerId) => post('/Interclub/team_roster_remove', { team_id: teamId, player_id: playerId }),

  // ── Joueurs connectés et ERP ──
  /** Staff : toutes les équipes du club → { teams[] (standing, next_fixture), upcoming[], recent[], competitions[] } */
  my: () => v2Api.get('/Interclub/my', STAFF_MODE).then((r) => r.data),
  /** → { competition, division, standings[], fixtures[] } */
  division: (id) => post('/Interclub/division', { id }),
  /** → { team, roster[], fixtures[], t1, standing, can_manage } */
  team: (id) => post('/Interclub/team', { id }),
  /** → InterclubFixtureViewDto (compositions, matchs, effectifs, avertissements) */
  fixture: (id) => post('/Interclub/fixture', { id }),
  /** `players: [{ position, player_id? | guest_name? }]` */
  lineup: (fixtureId, teamId, players) => post('/Interclub/lineup', { fixture_id: fixtureId, team_id: teamId, players }),
  /** `{ fixture_id, forfeit_team_id?, matches: [{ position, home?, away?, units: [{ side1, side2 }] }] }` */
  result: (body) => post('/Interclub/result', body),
  matchScore: (matchId, units) => post('/Interclub/match_score', { match_id: matchId, units }),
  sportyhq: (fixtureId, encoded) => post('/Interclub/sportyhq', { fixture_id: fixtureId, encoded: Boolean(encoded) }),
};
